import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--bubble",
  "use": "icon-arrow--bubble-usage",
  "viewBox": "0 0 13 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 7\" id=\"icon-arrow--bubble\"><path d=\"m6.5 0 5.63 6.75H.87L6.5 0Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol